<template>
  <div class="layoutPadding mt-2">
    <div class="row ml-0 mr-0 w-100">
      <div class="col-md-3 pl-0" style="padding-right: 5px">
        <LpDashboardCompanyCard></LpDashboardCompanyCard>
      </div>
      <div class="col-md-9 pl-0 pr-0">
        <div class="row ml-0 mr-0 w-100">
          <div class="row ml-0 mr-0 w-100">
            <div class="col-md-12">
              <div class="card fundCard">
                <div class="d-flex" style="margin-bottom: 15px">
                  <div class="fundInformartionMainCls">Fund Information</div>
                  <div
                    class="d-flex"
                    style="
                      margin-left: 5px;
                      margin-top: auto;
                      margin-bottom: auto;
                    "
                    v-tooltip.top-end="toolTipInfo"
                  >
                    <img src="static/img/graphInfo.svg" class />
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <div class="fundInformartionSubCls">Fund Size</div>
                    <div class="fundInformartionValueCls">
                      {{
                        thesisData && thesisData[0] && thesisData[0].size
                          ? `$${precisionNumberForamtter(
                              thesisData[0].size,
                              1
                            )}`
                          : 0
                      }}
                    </div>
                  </div>
                  <div>
                    <div class="fundInformartionSubCls">Companies</div>
                    <div class="fundInformartionValueCls">
                      {{
                        fundKpiData &&
                        fundKpiData[0] &&
                        fundKpiData[0].fund_no_of_companies
                          ? fundKpiData[0].fund_no_of_companies
                          : 0
                      }}
                    </div>
                  </div>
                  <div>
                    <div class="fundInformartionSubCls">Value of Portfolio</div>
                    <div class="fundInformartionValueCls">
                      {{
                        fundKpiData &&
                        fundKpiData[0] &&
                        fundKpiData[0].fund_value_of_portfolio
                          ? `$${precisionNumberForamtter(
                              fundKpiData[0].fund_value_of_portfolio,
                              1
                            )}`
                          : 0
                      }}
                    </div>
                  </div>
                  <div>
                    <div class="fundInformartionSubCls">MOIC</div>
                    <div class="fundInformartionValueCls">
                      {{
                        fundKpiData &&
                        fundKpiData[0] &&
                        fundKpiData[0].fund_moic
                          ? fundKpiData[0].fund_moic
                          : 0
                      }}
                    </div>
                  </div>
                  <div>
                    <div class="fundInformartionSubCls">TVPI</div>
                    <div class="fundInformartionValueCls">
                      {{
                        fundKpiData &&
                        fundKpiData[0] &&
                        fundKpiData[0].fund_tvpi
                          ? fundKpiData[0].fund_tvpi
                          : 0
                      }}
                    </div>
                  </div>
                  <div>
                    <div class="fundInformartionSubCls">DPI</div>
                    <div class="fundInformartionValueCls">
                      {{
                        fundKpiData && fundKpiData[0] && fundKpiData[0].fund_dpi
                          ? fundKpiData[0].fund_dpi
                          : 0
                      }}
                    </div>
                  </div>
                  <div
                    v-if="
                      fundKpiData && fundKpiData[0] && fundKpiData[0].fund_irr
                    "
                  >
                    <div class="fundInformartionSubCls">IRR</div>
                    <div class="fundInformartionValueCls">
                      {{
                        fundKpiData && fundKpiData[0] && fundKpiData[0].fund_irr
                          ? fundKpiData[0].fund_irr
                          : 0
                      }}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ml-0 mr-0 w-100">
          <div class="col-md-6">
            <div class="lpDashboardStatusChart">
              <pie-commitment-chart-card></pie-commitment-chart-card>
            </div>
          </div>

          <div class="col-md-6" style="padding-left: 5px">
            <div
              class="lpDashboardStatusChart lpDashboardStatusSemiCircleChart"
            >
              <pie-status-chart-card></pie-status-chart-card>
            </div>
          </div>
        </div>
        <div class="row ml-0 mr-0 w-100">
          <div class="col-md-6">
            <div class="lpDashboardStatusChart dashboardGraphs">
              <newsFeedCard
                :newsFeedList="newsFeedList"
                context="lpDashboard"
              ></newsFeedCard>
            </div>
          </div>
          <div class="col-md-6" style="padding-left: 5px">
            <LpDashboardPortfolioPerformance></LpDashboardPortfolioPerformance>
          </div>
        </div>
        <div class="row ml-0 mr-0 w-100">
          <div class="col-md-6">
            <div class="lpDashboardStatusChart lpDashboardBarChart">
              <callsDistributionsChartCard></callsDistributionsChartCard>
            </div>
          </div>
          <div class="col-md-6" style="padding-left: 5px">
            <div class="lpDashboardStatusChart">
              <line-dpi-chart-card></line-dpi-chart-card>
            </div>
          </div>
        </div>
        <div class="row ml-0 mr-0 w-100">
          <div class="col-md-6">
            <div class="lpDashboardStatusChart">
              <lp-gender-chart></lp-gender-chart>
            </div>
          </div>
          <div class="col-md-6" style="padding-left: 5px">
            <div class="lpDashboardStatusChart">
              <notesCard
                ref="noteRef"
                :data="{ currentCompany: fund }"
              ></notesCard>
            </div>
          </div>
        </div>
        <div class="row ml-0 mr-0 w-100">
          <div class="col-md-6">
            <div class="lpDashboardStatusChart lpDashboardBarChart">
              <bar-lp-chart-card
                :property="'geography'"
                :title="'Portfolio Geography'"
              ></bar-lp-chart-card>
            </div>
          </div>
          <div class="col-md-6" style="padding-left: 5px">
            <div class="lpDashboardStatusChart lpDashboardBarChart">
              <bar-lp-chart-card
                :property="'name'"
                :title="'Portfolio Industries'"
              ></bar-lp-chart-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StatusPieChartCard from "../../../components/Cards/DefinedCharts/StatusPieChartCard";
import BarIndustriesChartCard from "../../../components/Cards/DefinedCharts/BarIndustriesChartCard";
import LpGenderPieChartCard from "../../../components/Cards/DefinedCharts/LpGenderPieChartCard";
import LpDashboardCompanyCard from "../../../components/Cards/LpDashboardCompanyCard";
import LpDashboardPortfolioPerformance from "../../../components/Cards/LpDashboardPortfolioPerformance";
import { precisionNumberForamtter } from "../../../util";
import { mapGetters } from "vuex";
import api from "../../../axios_api";
import NewsFeedCard from "../../../components/Cards/NewsFeedCard";
import CommitmentPieChartCard from "../../../components/Cards/DefinedCharts/CommitmentPieChartCard";
import DpiLineChartCard from "../../../components/Cards/DefinedCharts/DpiLineChartCard";
import CallsDistributionsChartCard from "../../../components/Cards/DefinedCharts/CallsDistributionsChartCard";
import NotesCard from "../../../components/Cards/NotesCard";
export default {
  name: "lpDashboard",
  components: {
    [StatusPieChartCard.name]: StatusPieChartCard,
    [BarIndustriesChartCard.name]: BarIndustriesChartCard,
    [LpGenderPieChartCard.name]: LpGenderPieChartCard,
    LpDashboardCompanyCard,
    [NewsFeedCard.name]: NewsFeedCard,
    [CommitmentPieChartCard.name]: CommitmentPieChartCard,
    [DpiLineChartCard.name]: DpiLineChartCard,
    LpDashboardPortfolioPerformance,
    [CallsDistributionsChartCard.name]: CallsDistributionsChartCard,
    [NotesCard.name]: NotesCard,
  },
  computed: {
    ...mapGetters("portfolio", ["fund"]),
    ...mapGetters("lpAllocations", [
      "thesisData",
      "capitalCallData",
      "distributionData",
    ]),
    ...mapGetters("charts", ["fundKpiData"]),
    toolTipInfo() {
      // right now just return the default (only) string
      return "Information on your dashboard is collected from the Summary menu item on the left";
    },
  },
  data() {
    return {
      newsFeedList: [],
    };
  },
  methods: {
    precisionNumberForamtter: precisionNumberForamtter,
    getNewsFeed() {
      let self = this;
      api
        .get(`/lp/global/newsFeed/${this.$route.params.workspace_id}`)
        .then((data) => {
          if (
            data.data &&
            data.data.encrypt &&
            data.data.encrypt.success &&
            data.data.encrypt.success[0] &&
            data.data.encrypt.success[0][0]
          ) {
            let list = [];
            let newsList = data.data.encrypt.success[0][0];
            if (
              newsList &&
              newsList.data_cb_uuids &&
              newsList.data_cb_uuids.status
            ) {
              newsList.data_cb_uuids.feed.map((item) => list.push(item));
            }
            if (
              newsList &&
              newsList.data_rss_company_list &&
              newsList.data_rss_company_list.status
            ) {
              newsList.data_rss_company_list.feed.map((item) =>
                list.push(item)
              );
            }
            self.newsFeedList = list.sort((a, b) => {
              return new Date(b.time) - new Date(a.time);
            });
          }
        })
        .catch((err) => {
          console.log({ err });
        });
    },
  },
  mounted() {
    if (
      this.fund &&
      this.fund.hasOwnProperty("permalink") &&
      this.fund.permalink &&
      this.fund.name
    ) {
      this.getNewsFeed();
      const titleEl = document.querySelector("head title");
      titleEl.textContent = `Fiifi | ${this.fund.name}`;
    }
    this.$store.dispatch(
      "charts/getFundKpiData",
      this.$route.params.workspace_id
    );
  },
};
</script>
<style>
.fundCard {
  margin-bottom: 15px;
  padding: 20px;
}
.lpDashboardStatusChart .card {
  height: 315px;
  overflow: hidden;
  margin-bottom: 15px;
}

.lpDashboardStatusChart .card .card-body canvas {
  height: 250px !important;
}

.lpDashboardBarChart .card .card-body canvas {
  height: 250px !important;
}

.lpDashboardStatusChart .notesCard {
  height: 315px;
  min-height: 315px;
  max-height: 315px;
}

.lpDashboardStatusChart .notesCardBodyLayout {
  height: 250px;
  min-height: 250px;
  max-height: 250px;
  overflow: auto;
  padding-top: 5px;
}

.lpDashboardStatusSemiCircleChart .card .card-body canvas {
  height: 180px !important;
}

.lpDashboardStatusSemiCircleChart .card .card-body {
  padding-top: 50px;
}
</style>